import React from 'react';
import withRouter from './withRouter';

const RightSidebar = (props) => {   

    window.onscroll = function () {
        scrollFunction();
    };

    const scrollFunction = () => {
        const element = document.getElementById("back-to-top");
        if (element) {
            if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) element.style.display = "block";
            else element.style.display = "none";            
        }
    };

    const toTop = () => {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    };

    return (
        <React.Fragment>
            <button className="btn btn-primary btn-icon" id="back-to-top" onClick={() => toTop()}>
                <i className="ri-arrow-up-line"/>
            </button>
        </React.Fragment>
    );
};

export default withRouter(RightSidebar);